<script>
import Detail from "@/components/detail.vue";

export default {
  components: {Detail},
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      persons: []
    };
  },
  methods: {
    showModel(v) {
      this.$emit('open', v.detail());
    },
    then() {
      if (this.value.lafil014.length === 0) {
        return;
      }

      for (const lafil014 of this.value.lafil014) {
        if (!lafil014.lafil013) {
          continue;
        }

        this.persons = this.persons.concat(lafil014.lafil013.persons);
      }
    }
  }
};
</script>

<template>
  <detail v-model="value" relations="lafil014.lafil013.persons" :then="then">
    <template #default>
      <b-card-body>
        <b-img class="img-fluid" :src="`/api/notebooks/${value.id}/image`"></b-img>

        <blockquote v-if="persons.length !== 0" class="text-capitalize mt-2">
          Personnes :
          <template v-for="(model, k) in persons">
            <span :key="model.id" @click="showModel(model)" class="hover-cursor-pointer">{{ model }}</span>
            <template v-if="k + 1 !== persons.length">; </template>
          </template>
        </blockquote>
      </b-card-body>
    </template>
  </detail>
</template>
